/**
 * +field: a small WoW-window style panel for town NPCs (Elder Rowan's dialog, the Bounty Board):
 * portrait crest + name/title header, a body the caller fills, a close button; Esc closes it.
 * One panel at a time (opening another closes the first).
 */
import { el } from '../dom';

export interface TownPanel {
  root: HTMLElement;
  body: HTMLElement;
  foot: HTMLElement;
  close(): void;
  readonly closed: boolean;
}

let open: TownPanel | null = null;

export function closeTownPanel(): void {
  open?.close();
}

export function townPanelOpen(): boolean {
  return !!open && !open.closed;
}

export function openTownPanel(parent: HTMLElement, o: { title: string; subtitle?: string; className?: string; onClose?: () => void }): TownPanel {
  open?.close();
  const root = el('div', `fx-panel ${o.className ?? ''}`.trim(), parent);
  root.setAttribute('role', 'dialog');
  const head = el('div', 'fx-panel-head', root);
  const names = el('div', 'fx-panel-names', head);
  el('div', 'fx-panel-title', names, o.title);
  if (o.subtitle) el('div', 'fx-panel-sub', names, o.subtitle);
  const x = el('button', 'fx-panel-x', head, '×');
  x.type = 'button';
  x.title = 'Close (Esc)';
  const body = el('div', 'fx-panel-body', root);
  const foot = el('div', 'fx-panel-foot', root);
  let closed = false;
  const onKey = (e: KeyboardEvent): void => {
    if (e.code !== 'Escape' || closed) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    panel.close();
  };
  const panel: TownPanel = {
    root,
    body,
    foot,
    get closed() {
      return closed;
    },
    close() {
      if (closed) return;
      closed = true;
      window.removeEventListener('keydown', onKey, { capture: true });
      root.remove();
      if (open === panel) open = null;
      o.onClose?.();
    },
  };
  x.addEventListener('click', () => panel.close());
  // Clicks inside the panel never reach the game (no deselect / camera drag).
  root.addEventListener('pointerdown', (e) => e.stopPropagation());
  window.addEventListener('keydown', onKey, { capture: true });
  open = panel;
  return panel;
}
